import cn from "classnames";
import { forwardRef } from "react";
import { capitalize } from "../../lib";
import type { EmojiItem } from "../../model";
import { EmojiPanelItem } from "../EmojiPanelItem";
import styles from "./EmojiPanelLine.module.scss";

type Props = {
    emojiList: EmojiItem[];
    onClick: (emoji: EmojiItem) => void;
    disableTooltip?: boolean;
    size: "s" | "m";
    emojiGroup: string;
};

export const EmojiPanelLine = forwardRef<HTMLDivElement, Props>(function EmojiPanelLine(
    { emojiList, onClick, disableTooltip, size, emojiGroup },
    ref,
) {
    return (
        <div
            ref={ref}
            data-group={emojiGroup}
            className={cn(styles.emojiPanelLine, styles[`emojiPanelLineSize${capitalize(size)}`])}
        >
            {emojiList.map((emoji) => (
                <EmojiPanelItem
                    key={emoji.id}
                    emoji={emoji}
                    disableTooltip={disableTooltip}
                    size={size}
                    onClick={onClick}
                />
            ))}
        </div>
    );
});
